import { Flame, Trophy, Plus, LogIn, LogOut, User } from "lucide-react";
import { Button } from "@/components/ui/button";
import { useApp } from "@/App";

interface HeaderProps {
	currentPage: string;
}

export function Header({ currentPage }: HeaderProps) {
	const { currentUser, logout, navigate, showLogin } = useApp();

	return (
		<header className="sticky top-0 z-50 border-b border-border/40 bg-background/80 backdrop-blur-xl">
			<div className="mx-auto flex max-w-4xl items-center justify-between px-4 py-3">
				<button
					onClick={() => navigate({ name: "feed" })}
					className="flex items-center gap-2 transition-opacity hover:opacity-80"
				>
					<Flame className="h-6 w-6 text-orange-500" />
					<span className="text-lg font-bold tracking-tight">Roast My Landing Page</span>
				</button>

				<nav className="flex items-center gap-1">
					<Button
						variant={currentPage === "feed" ? "secondary" : "ghost"}
						size="sm"
						onClick={() => navigate({ name: "feed" })}
					>
						<Flame className="mr-1.5 h-4 w-4" />
						Feed
					</Button>
					<Button
						variant={currentPage === "leaderboard" ? "secondary" : "ghost"}
						size="sm"
						onClick={() => navigate({ name: "leaderboard" })}
					>
						<Trophy className="mr-1.5 h-4 w-4" />
						Leaderboard
					</Button>
					<Button
						variant={currentPage === "submit" ? "secondary" : "ghost"}
						size="sm"
						onClick={() => navigate({ name: "submit" })}
						className="text-orange-500 hover:text-orange-400"
					>
						<Plus className="mr-1.5 h-4 w-4" />
						Submit
					</Button>

					{currentUser ? (
						<div className="ml-2 flex items-center gap-1">
							<Button
								variant="ghost"
								size="sm"
								onClick={() => navigate({ name: "profile", id: currentUser.id })}
								className="gap-1.5"
							>
								<div className="flex h-6 w-6 items-center justify-center rounded-full bg-orange-500/20 text-xs font-bold text-orange-500">
									{currentUser.username[0].toUpperCase()}
								</div>
								<span className="max-w-[80px] truncate text-xs">{currentUser.username}</span>
							</Button>
							<Button variant="ghost" size="icon" className="h-8 w-8" onClick={logout}>
								<LogOut className="h-4 w-4" />
							</Button>
						</div>
					) : (
						<Button variant="ghost" size="sm" onClick={showLogin} className="ml-2">
							<LogIn className="mr-1.5 h-4 w-4" />
							Login
						</Button>
					)}
				</nav>
			</div>
		</header>
	);
}
